import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { FailedAttempts } from './components/FailedAttempts';
import { UniqueMechanism } from './components/UniqueMechanism';
import { SessionBenefits } from './components/SessionBenefits';
import { Testimonials } from './components/Testimonials';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
export function App() {
  return <div className="min-h-screen bg-navy text-white font-inter selection:bg-gold selection:text-navy" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <Problem data-id="element-3" />
      <FailedAttempts data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <SessionBenefits data-id="element-6" />
      <Testimonials data-id="element-7" />
      <Audience data-id="element-8" />
      <HowItWorks data-id="element-9" />
      <FAQ data-id="element-10" />
      <CTA data-id="element-11" />

      <footer className="bg-navy py-8 border-t border-white/5 text-center text-gray-dark text-sm" data-id="element-12">
        <div className="max-w-5xl mx-auto px-6" data-id="element-13">
          <p data-id="element-14">
            © {new Date().getFullYear()} El Protocolo del Retiro Blindado.
            Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}